<app-feature-hero
    variant="ims"
    title="Network Protocols"
    description="Sets of rules and standards that control the communication between devices on a computer network"
    image="/assets/img/feature-pages/infraon-ims/network-topology/nms-network-topology-header-bg.png"
    imageAlt="Network Protocols hero image"
></app-feature-hero>


<section class="container section-spacing">
    <div class="row align-items-center">
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <div class="illustrated-feature-container-text-left">
                <h2 class="section-title">What are Network Protocols?</h2>
                <p class="section-paragraph">Network Protocols are the rules and standards that govern how devices on a
                    network interact with one another. They specify how data is transmitted and the procedures for
                    detecting and rectifying errors. In other words, Network Protocols may be compared to languages that
                    two devices must understand to communicate information seamlessly, independent of infrastructure or
                    design differences. Some commonly used Network Protocols are TCP/IP, HTTP, FTP, DNS, and DHCP.</p>
            </div>
        </div>
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <img src="/assets/img/feature-pages/infraon-ims/network-topology/nms-network-topology-feature-img-1.webp" class="w-100"
                alt="Ticket assignment to helpdesk executive">
        </div>
    </div>
</section>

<section class="container section-spacing">
    <div id="gdpr-wrapper">
        <div class="gdpr-section justify-content-center">
            <img src="/assets/img/feature-pages/gdpr.webp" alt="GDPR Logo" class="me-4 w-100">
            <div>
                <h2 class="section-title mb-3">Our Product Suite is GDPR-Compliant</h2>
                <p class="section-paragraph mb-0">We are compliant with the European General Data Protection Regulation (GDPR) – and <br> our SaaS-based product suite is fully committed to protecting the data of our customers <br> as per the recent standards.</p>
            </div>
        </div>
    </div>
</section>  

<style>
    .infiy-sliders h2 {
        margin-bottom: 84px !important;
    }

    .infiy-sliders .infiy-slides {
        border: 1px solid #D8D8E3;
        border-radius: 0px 24px 24px 0px;
        margin-bottom: 14px;
        padding: 32px 36px;
        cursor: pointer;
        /* transition: all 0.5s; */
    }

    .infiy-slides.active {
        background-color: #F1F4FE;
        border-left: 4px solid #1A5AD9;
    }

    .infiy-slides p {
        display: none;
    }

    .infiy-slides.active p {
        display: block;
    }

    .infiy-slides a {
        display: none;
    }

    .infiy-slides.active a {
        display: block;
    }

    .infiy-slides h3 {
        font-size: 24px;
        letter-spacing: 0;
        margin-bottom: 0 !important;
    }

    .slider-imgs {
        width: 90%;
    }

    .infiy-sliders .infiy-slides {
        padding: 15px 15px;
        border-radius: 0px 14px 14px 0px;
    }

    .infiy-slides h3 {}

    .infiy-slides p {
        margin-top: 1rem;
        margin-bottom: 1rem;
    }
</style>


<section class="container section-spacing infiy-sliders">
    <h2 class="section-title text-center">Purposes of Network Topology</h2>
    <div class="row mx-0 columns-wrapper align-items-center">
        <div class="col-lg-6 col-md-12">
            <div class="slider-buttons" (mouseenter)="stopInterval()" (mouseleave)="startInterval()">
                <div *ngFor="let slide of slides; let i = index" class="infiy-slides" [class.active]="i === activeIndex" (click)="setActive(i)" data-aos="fade-up" >
                    <h3 class="section-title-s text-start">
                        {{ slide.title }}
                    </h3>
                    <p class="section-paragraph-s text-start mb-0">
                        {{ slide.description }}
                    </p>
                </div>
            </div>
        </div>

        <div class="col-lg-6 col-md-12">
            <img
                loading="lazy"
                data-aos="fade-left"
                data-aos-delay="250"
                [src]="imageSrc"
                class="d-block mx-auto slider-imgs"
                alt="Purposes of Network Topology"
            />
        </div>
    </div>
</section>

<section class="container section-spacing">
    <h2 class="section-title text-center">Benefits of Network Topology</h2>

    <div class="row mx-0 align-items-center section-spacing pt-0">
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <div class="illustrated-feature-container-text-left">
                <h3 class="section-title">Enhances Flexibility</h3>
                <p class="section-paragraph">Various network topologies offer flexibility in terms of connectivity
                    options. Organizations can choose the most suitable topology based on their specific requirements,
                    whether centralized control in a star topology or redundant paths in a mesh topology.</p>
            </div>
        </div>
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <img loading="lazy" class="features-images"
                src="/assets/img/feature-pages/infraon-ims/network-topology/nms-network-topology-feature-img-2.svg"
                alt="Benefits of Network Topology">
        </div>
    </div>

    <div class="row mx-0 align-items-center section-spacing reverse-column">
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <img loading="lazy" class="features-images"
                src="/assets/img/feature-pages/infraon-ims/network-topology/itsm-service-request-management-feature-3-01.png"
                alt="Optimizes Performance">
        </div>
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <h3 class="section-title">Optimizes Performance</h3>
            <p class="section-paragraph">Network topology design plays a crucial role in optimizing performance. By
                strategically organizing devices, connections, and data flows, IT professionals can minimize latency,
                bottlenecks, and congestion, improving network performance and faster data transmission.</p>
        </div>
    </div>

    <div class="row mx-0 align-items-center section-spacing">
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <div class="illustrated-feature-container-text-left">
                <h3 class="section-title">Improves Resource Utilization</h3>
                <p class="section-paragraph">Proper network topology design ensures efficient resource utilization. By
                    optimizing data flow paths and minimizing unnecessary data transmission, network resources such as
                    bandwidth, processing power, and storage capacity are utilized effectively, leading to cost savings
                    and improved overall performance.</p>
            </div>
        </div>
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <img loading="lazy" class="features-images"
                src="/assets/img/feature-pages/infraon-ims/network-topology/itsm-workflow-management-feature-2-01.png" alt="Config Sliders">
        </div>
    </div>

    <div class="row mx-0 align-items-center section-spacing pb-0 reverse-column">
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <img loading="lazy" class="features-images"
                src="/assets/img/feature-pages/infraon-ims/network-topology/nms-network-topology-feature-img-3.svg" alt="Improves Fault Tolerance">
        </div>
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <div class="illustrated-feature-container-text-right">
                <h3 class="section-title">Improves Fault Tolerance</h3>
                <p class="section-paragraph">Certain network topologies, such as mesh or ring, provide inherent fault
                    tolerance. If a single link or device fails, alternative paths are available for data transmission,
                    ensuring uninterrupted connectivity and reducing the impact of failures.</p>
            </div>
        </div>
    </div>

    <div class="row mx-0 align-items-center section-spacing pt-0">
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <div class="illustrated-feature-container-text-left">
                <h3 class="section-title">Enhances Security</h3>
                <p class="section-paragraph">Network topology can contribute to enhancing security measures within an IT
                    infrastructure. For example, a segmented topology can isolate critical systems or sensitive data
                    from the rest of the network, reducing the potential attack surface.</p>
            </div>
        </div>
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <img loading="lazy" class="features-images"
                src="/assets/img/feature-pages/infraon-ims/network-topology/nms-network-topology-feature-img-4.svg" alt="Shield Illustration">
        </div>
    </div>

    <div class="row mx-0 align-items-center section-spacing reverse-column">
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <img loading="lazy" class="features-images"
                src="/assets/img/feature-pages/infraon-ims/network-topology/nms-network-topology-feature-img-5.svg"
                alt="Device Connection management">
        </div>
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <h3 class="section-title">Simplifies Management</h3>
            <p class="section-paragraph">A well-designed network topology simplifies network management and
                troubleshooting tasks. Clear and organized connectivity patterns make it easier to identify and resolve
                issues and manage network configurations, updates, and maintenance activities.</p>
        </div>
    </div>

    <div class="row mx-0 align-items-center section-spacing" style="padding-bottom: 0!important;">
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <div class="illustrated-feature-container-text-left">
                <h3 class="section-title">Improves Collaboration and Communication</h3>
                <p class="section-paragraph">Network topology facilitates seamless collaboration and communication among
                    users and devices. Connecting devices logically and efficiently allow users to share resources,
                    data, and applications, enabling better teamwork and productivity.</p>
            </div>
        </div>
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <img loading="lazy" class="features-images" width="100%"
                src="/assets/img/feature-pages/infraon-ims/network-topology/nms-network-topology-feature-img-6.webp"
                alt="Image showing network topology features in NMS">
        </div>
    </div>
</section>

<section class="container section-spacing">
    <h2 class="section-title text-center p-b-60">Types of Network Topologies</h2>

    <div class="row mx-0 justify-content-evenly">
        <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 px-5 mb-5">
            <svg style="max-height: 26px;margin-bottom:20px;" xmlns="http://www.w3.org/2000/svg" width="33" height="28"
                viewBox="0 0 33 28" fill="none">
                <path
                    d="M31.2205 13.1797L28.3792 8.43281C28.4416 8.31797 28.4869 8.18125 28.4869 8.03906C28.4869 7.60156 28.107 7.23516 27.6532 7.21875L24.5114 1.97422C24.5397 1.88672 24.5737 1.79922 24.5737 1.71172C24.5737 1.24141 24.1767 0.875 23.706 0.875C23.4338 0.875 23.207 0.989844 23.0368 1.18125H16.9855C16.8324 0.989844 16.6056 0.875 16.3333 0.875C16.0611 0.875 15.8343 0.989844 15.6811 1.18125H9.6639C9.49943 0.989844 9.26691 0.875 8.99469 0.875C8.52397 0.875 8.12698 1.24141 8.12698 1.71172C8.12698 1.79922 8.15533 1.90312 8.18936 1.97422L5.01344 7.28984C4.70719 7.42109 4.49735 7.7 4.49735 8.03906C4.49735 8.06641 4.51436 8.09922 4.51436 8.12656L1.49156 13.1633C1.08323 13.2344 0.776978 13.5734 0.776978 13.9836C0.776978 14.3773 1.06621 14.7164 1.4632 14.8039L4.59376 20.0211C4.5654 20.1086 4.54839 20.1797 4.54839 20.2836C4.54839 20.6773 4.83763 21.0164 5.23462 21.0875L8.16668 25.993C8.13832 26.0805 8.10429 26.1844 8.10429 26.2883C8.10429 26.7586 8.50128 27.125 8.972 27.125C9.24422 27.125 9.47108 27.0102 9.6242 26.8297H15.6868C15.8343 27.0102 16.0725 27.125 16.3333 27.125C16.5942 27.125 16.8324 27.0102 16.9855 26.8297H23.0595C23.2126 26.9883 23.4395 27.0922 23.6833 27.0922C24.1711 27.0922 24.5511 26.7094 24.5511 26.2555C24.5511 26.168 24.534 26.0969 24.5057 26.0203L27.4377 21.082C27.8347 21.0109 28.124 20.6719 28.124 20.2781C28.124 20.1906 28.107 20.1031 28.0786 20.0156L31.1921 14.7984C31.5891 14.7273 31.8897 14.3883 31.8897 13.9781C31.8897 13.5844 31.6005 13.2453 31.2205 13.1742V13.1797ZM8.70545 24.6477L6.22709 20.5023H8.70545V24.6477ZM8.70545 20.0648H6.22709C6.21008 20.0047 6.18172 19.95 6.15337 19.8898L8.70545 17.2977V20.0648ZM8.70545 16.6523L5.84712 19.5672C5.77339 19.5398 5.69399 19.4961 5.62026 19.4797L2.46135 14.2078C2.48971 14.1367 2.48971 14.0602 2.48971 13.9891C2.48971 13.918 2.48971 13.8578 2.47269 13.7977L5.42177 8.87578C5.57489 8.85938 5.72802 8.81563 5.86413 8.72813L8.70545 11.5719V16.6523ZM8.70545 11.0578L6.108 8.46563C6.18172 8.35078 6.22709 8.20312 6.22709 8.03906C6.22709 8.02266 6.21008 7.99531 6.21008 7.97891L8.69978 7.11484V11.0578H8.70545ZM8.70545 6.65L6.22709 7.51406L8.70545 3.38516V6.65ZM27.2222 8.78828L27.2676 8.85938L25.2656 17.9977L21.6473 14.3227L27.2052 8.77187L27.2222 8.78828ZM16.5489 19.4195L17.201 20.0648H15.908L16.5489 19.4195ZM16.5318 18.8016L11.8076 14.1312L16.322 9.51562L21.0292 14.3063L16.5318 18.8016ZM16.8381 19.1242L21.3354 14.6289L25.1636 18.5281L24.8289 20.0648H17.7909L16.8324 19.1297L16.8381 19.1242ZM23.275 2.42813C23.3374 2.45547 23.3941 2.48828 23.4735 2.49922L26.7572 8.00625V8.03359C26.7572 8.19219 26.8026 8.33984 26.8763 8.46016L21.3468 14L16.6396 9.20937L23.275 2.42813ZM22.7589 2.31328L16.3163 8.88672L13.078 5.58906L22.5094 2.30781H22.7533L22.7589 2.31328ZM15.7549 2.31328C15.908 2.46094 16.1065 2.54844 16.3333 2.54844C16.5602 2.54844 16.7587 2.46094 16.9118 2.31328H21.1653L12.7491 5.23906L9.86239 2.31328H15.7549ZM9.16483 2.61953L9.22721 2.50469C9.27886 2.49216 9.32994 2.47757 9.38033 2.46094L12.284 5.40313L9.1705 6.48594V2.61953H9.16483ZM9.16483 6.95625L12.613 5.75312L15.9987 9.20937L11.4844 13.8086L9.15915 11.5062V6.95078L9.16483 6.95625ZM9.16483 12.0258L11.2292 14.0875L9.16483 16.182V12.0203V12.0258ZM9.16483 16.8328L11.5524 14.3992L16.2483 19.1023L15.2785 20.0703H9.16483V16.8328ZM9.56182 25.6977C9.47108 25.6102 9.36332 25.55 9.22721 25.5063L9.16483 25.4187V20.5133H14.8305L9.63554 25.6977H9.56182ZM16.9288 25.6977C16.7757 25.5664 16.5659 25.4625 16.339 25.4625C16.1122 25.4625 15.8967 25.5664 15.7492 25.6977H10.2821L15.477 20.5133H17.6491L22.844 25.6977H16.9232H16.9288ZM23.7344 25.0523L23.4905 25.4625C23.4168 25.4789 23.3544 25.5063 23.292 25.5336L18.2332 20.5078H24.7212L23.7344 25.0469V25.0523ZM24.466 23.8383L25.1976 20.5133H26.4453L24.4717 23.8383H24.466ZM26.4396 20.0758H25.2826L25.5435 18.9164L26.5133 19.9117C26.485 19.9555 26.4509 20.0156 26.4396 20.0703V20.0758ZM30.194 14.2023L27.0521 19.4906C26.9784 19.518 26.899 19.5508 26.8252 19.5945L25.657 18.3914L27.6192 9.42812L30.2167 13.7648C30.1997 13.8359 30.1713 13.9125 30.1713 14C30.1713 14.0711 30.1883 14.1312 30.1997 14.2078L30.194 14.2023Z"
                    fill="#084CD4" />
            </svg>
            <p class="section-title-s text-start">Bus Topology</p>
            <p class="section-paragraph-s text-start">All devices are connected to a central cable (bus). Data is
                transmitted along the bus, and each device receives it, but it is processed only by the intended
                recipient.</p>
        </div>

        <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 px-5 mb-5">
            <svg style="max-height: 26px;margin-bottom:20px;" xmlns="http://www.w3.org/2000/svg" width="28" height="29"
                viewBox="0 0 28 29" fill="none">
                <path
                    d="M14 0.5C21.3281 0.5 26.25 2.46875 26.25 4.875V7.5C27.1797 7.5 28 8.32031 28 9.25V12.75C28 13.7344 27.1797 14.5 26.25 14.5V23.25C26.25 24.2344 25.4297 25 24.5 25V26.75C24.5 27.7344 23.6797 28.5 22.75 28.5H21C20.0156 28.5 19.25 27.7344 19.25 26.75V25H8.75V26.75C8.75 27.7344 7.92969 28.5 7 28.5H5.25C4.26562 28.5 3.5 27.7344 3.5 26.75V25C2.51562 25 1.75 24.2344 1.75 23.25V14.5C0.765625 14.5 0 13.7344 0 12.75V9.25C0 8.32031 0.765625 7.5 1.75 7.5V4.875C1.75 2.46875 6.61719 0.5 14 0.5ZM5.25 9.25V14.5C5.25 15.4844 6.01562 16.25 7 16.25H13.125V7.5H7C6.01562 7.5 5.25 8.32031 5.25 9.25ZM14.875 16.25H21C21.9297 16.25 22.75 15.4844 22.75 14.5V9.25C22.75 8.32031 21.9297 7.5 21 7.5H14.875V16.25ZM6.125 22.375C7.05469 22.375 7.875 21.6094 7.875 20.625C7.875 19.6953 7.05469 18.875 6.125 18.875C5.14062 18.875 4.375 19.6953 4.375 20.625C4.375 21.6094 5.14062 22.375 6.125 22.375ZM21.875 22.375C22.8047 22.375 23.625 21.6094 23.625 20.625C23.625 19.6953 22.8047 18.875 21.875 18.875C20.8906 18.875 20.125 19.6953 20.125 20.625C20.125 21.6094 20.8906 22.375 21.875 22.375ZM19.25 4.875C19.25 4.4375 18.8125 4 18.375 4H9.625C9.13281 4 8.75 4.4375 8.75 4.875C8.75 5.36719 9.13281 5.75 9.625 5.75H18.375C18.8125 5.75 19.25 5.36719 19.25 4.875Z"
                    fill="#084CD4" />
            </svg>
            <p class="section-title-s text-start">Mesh Topology</p>
            <p class="section-paragraph-s text-start">Each device has a dedicated connection to every other device in
                the network. This provides redundancy and multiple paths for data transmission.</p>
        </div>

        <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 px-5 mb-5">
            <svg style="max-height: 26px;margin-bottom:20px;" xmlns="http://www.w3.org/2000/svg" width="30" height="29"
                viewBox="0 0 30 29" fill="none">
                <path
                    d="M16.5313 1.48438L20.086 8.75781L27.9063 9.90625C28.5625 10.0156 29.1094 10.4531 29.3282 11.1094C29.5469 11.7109 29.3828 12.4219 28.8907 12.8594L23.2032 18.4922L24.5703 26.4766C24.6797 27.1328 24.4063 27.7891 23.8594 28.1719C23.3125 28.6094 22.6016 28.6094 22 28.3359L15 24.5625L7.94534 28.3359C7.39847 28.6094 6.68753 28.6094 6.14065 28.1719C5.59378 27.7891 5.32034 27.1328 5.42972 26.4766L6.74222 18.4922L1.05472 12.8594C0.617215 12.4219 0.453153 11.7109 0.617215 11.1094C0.835965 10.4531 1.38284 10.0156 2.03909 9.90625L9.91409 8.75781L13.4141 1.48438C13.6875 0.882812 14.2891 0.5 15 0.5C15.6563 0.5 16.2578 0.882812 16.5313 1.48438Z"
                    fill="#084CD4" />
            </svg>
            <p class="section-title-s text-start">Star Topology</p>
            <p class="section-paragraph-s text-start">All devices are connected to a central hub or switch. Data is
                transmitted from one device to the central hub, which then broadcasts to all other devices.</p>
        </div>

        <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 px-5">
            <svg style="max-height: 26px;margin-bottom:20px;" xmlns="http://www.w3.org/2000/svg" width="26" height="29"
                viewBox="0 0 26 29" fill="none">
                <path
                    d="M12.2344 0.828125C12.4531 0.664062 12.6719 0.5 13 0.5C13.2734 0.5 13.5469 0.664062 13.7109 0.828125L21.8594 9.79688C22.0234 10.0156 22.1875 10.3438 22.1875 10.6172C22.1875 11.3281 21.5859 11.875 20.875 11.875H19.5625L23.5547 15.9219C23.7734 16.1406 23.9375 16.4688 23.9375 16.7969C23.9375 17.4531 23.3359 18 22.6797 18H20.875L24.9219 22.9219C25.1406 23.1406 25.25 23.4141 25.25 23.7422C25.25 24.4531 24.6484 25 23.9375 25H14.75V26.75C14.75 27.7344 13.9297 28.5 13 28.5C12.0156 28.5 11.25 27.7344 11.25 26.75V25H2.00781C1.29688 25 0.75 24.4531 0.75 23.7422C0.75 23.4141 0.804688 23.1406 1.02344 22.9219L5.125 18H3.26562C2.60938 18 2.0625 17.4531 2.0625 16.7969C2.0625 16.4688 2.17188 16.1406 2.39062 15.9219L6.4375 11.875H5.07031C4.35938 11.875 3.8125 11.3281 3.8125 10.6172C3.8125 10.3438 3.92188 10.0156 4.14062 9.79688L12.2344 0.828125Z"
                    fill="#084CD4" />
            </svg>
            <p class="section-title-s text-start">Tree Topology</p>
            <p class="section-paragraph-s text-start">Devices are arranged in a hierarchical tree-like structure. A
                central node connects multiple child nodes, which can further branch into sub-nodes.</p>
        </div>

        <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 px-5">
            <svg style="max-height: 26px;margin-bottom:20px;" xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" width="28px"
                height="21px" viewBox="0 0 28 21" style="enable-background:new 0 0 28 21;" xml:space="preserve">
                <path fill="#084CD4"
                    d="M3.5,7.9c0,0.4,0.2,1,0.9,1.7c2.5-1.3,5.9-2.1,9.6-2.1c3.7,0,7.1,0.8,9.5,2.1c0.7-0.7,1-1.3,1-1.7  c0-0.7-0.6-1.8-2.6-2.7c-2-1-4.7-1.6-7.9-1.6S8,4.2,6.1,5.1C4,6.1,3.5,7.2,3.5,7.9z M14,10.1c-2.6,0-4.9,0.4-6.7,1.1  c1.8,0.7,4.1,1.1,6.7,1.1c2.6,0,4.9-0.4,6.7-1.1C18.9,10.5,16.6,10.1,14,10.1z M0,7.9C0,5.2,2.1,3.2,4.5,2c2.5-1.3,5.9-2,9.5-2  c3.6,0,6.9,0.8,9.4,2C25.8,3.2,28,5.2,28,7.9v5.2c0,2.7-2.2,4.7-4.6,5.9c-2.5,1.3-5.9,2-9.4,2c-3.6,0-6.9-0.7-9.5-2  C2.1,17.8,0,15.9,0,13.1V7.9z" />
            </svg>
            <p class="section-title-s text-start">Ring Topology</p>
            <p class="section-paragraph-s text-start">Devices are connected in a circular loop, where data travels in
                one direction from device to device until it reaches the destination.</p>
        </div>

        <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 px-5">
            <svg style="max-height: 26px;margin-bottom:20px;" xmlns="http://www.w3.org/2000/svg" width="36" height="29"
                viewBox="0 0 36 29" fill="none">
                <path
                    d="M14.5 4V7.5H21.5V4H14.5ZM13.625 0.5H22.375C23.7969 0.5 25 1.70312 25 3.125V8.375C25 9.85156 23.7969 11 22.375 11H19.75V12.75H33.75C34.6797 12.75 35.5 13.5703 35.5 14.5C35.5 15.4844 34.6797 16.25 33.75 16.25H28.5V18H31.125C32.5469 18 33.75 19.2031 33.75 20.625V25.875C33.75 27.3516 32.5469 28.5 31.125 28.5H22.375C20.8984 28.5 19.75 27.3516 19.75 25.875V20.625C19.75 19.2031 20.8984 18 22.375 18H25V16.25H11V18H13.625C15.0469 18 16.25 19.2031 16.25 20.625V25.875C16.25 27.3516 15.0469 28.5 13.625 28.5H4.875C3.39844 28.5 2.25 27.3516 2.25 25.875V20.625C2.25 19.2031 3.39844 18 4.875 18H7.5V16.25H2.25C1.26562 16.25 0.5 15.4844 0.5 14.5C0.5 13.5703 1.26562 12.75 2.25 12.75H16.25V11H13.625C12.1484 11 11 9.85156 11 8.375V3.125C11 1.70312 12.1484 0.5 13.625 0.5ZM5.75 25H12.75V21.5H5.75V25ZM23.25 21.5V25H30.25V21.5H23.25Z"
                    fill="#084CD4" />
            </svg>
            <p class="section-title-s text-start">Hybrid Topology</p>
            <p class="section-paragraph-s text-start">It is a combination of two or more different types of network
                topologies. For example, a network might have a star-bus hybrid topology with multiple star topologies
                connected through a central bus</p>
        </div>
    </div>
</section>

<section class="container section-spacing">
    <h2 class="section-title text-center p-b-60">Key Benefits of Infraon's Network Topology Solution</h2>

    <div class="row mx-0 justify-content-start">
        <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 px-5 mb-5">
            <svg style="max-height: 26px;margin-bottom:20px;" xmlns="http://www.w3.org/2000/svg" width="32" height="25"
                viewBox="0 0 32 25" fill="none">
                <path
                    d="M16 0.25C20.375 0.25 23.9297 2.27344 26.5 4.67969C29.0703 7.03125 30.7656 9.875 31.5859 11.8438C31.75 12.2812 31.75 12.7734 31.5859 13.2109C30.7656 15.125 29.0703 17.9688 26.5 20.375C23.9297 22.7812 20.375 24.75 16 24.75C11.5703 24.75 8.01562 22.7812 5.44531 20.375C2.875 17.9688 1.17969 15.125 0.359375 13.2109C0.195312 12.7734 0.195312 12.2812 0.359375 11.8438C1.17969 9.875 2.875 7.03125 5.44531 4.67969C8.01562 2.27344 11.5703 0.25 16 0.25ZM23.875 12.5C23.875 8.17969 20.3203 4.625 16 4.625C11.625 4.625 8.125 8.17969 8.125 12.5C8.125 16.875 11.625 20.375 16 20.375C20.3203 20.375 23.875 16.875 23.875 12.5Z"
                    fill="#084CD4" />
                <path
                    d="M22 12.5C22 8.93403 19.2917 6 16 6C12.6667 6 10 8.93403 10 12.5C10 16.1111 12.6667 19 16 19C19.2917 19 22 16.1111 22 12.5ZM16 9.61111C16 9.11458 15.8333 8.61806 15.625 8.21181C15.75 8.21181 15.875 8.16667 16 8.16667C18.2083 8.16667 20 10.1076 20 12.5C20 14.8924 18.2083 16.8333 16 16.8333C13.7917 16.8333 12 14.8924 12 12.5C12 12.4097 12 12.2743 12 12.1389C12.375 12.3646 12.8333 12.5 13.3333 12.5C14.7917 12.5 16 11.2361 16 9.61111Z"
                    fill="#A8C1F1" />
            </svg>
            <p class="section-title-s text-start">Enhances Network Visibility</p>
            <p class="section-paragraph-s text-start">Infraon's network topology solution offers comprehensive
                visibility into the network infrastructure. This visibility helps troubleshoot, optimize performance,
                and make informed network management decisions.</p>
        </div>

        <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 px-5 mb-5">
            <svg style="max-height: 26px;margin-bottom:20px;" xmlns="http://www.w3.org/2000/svg" width="35" height="28"
                viewBox="0 0 35 28" fill="none">
                <path d="M3.5 12.75V23.25H0V12.75H3.5ZM35 12.75V23.25H31.5V12.75H35Z" fill="#A8C1F1" />
                <path
                    d="M19 0V1.75V5.25H29.5V28H5V5.25H15.5V1.75V0H19ZM14.1875 14C14.1875 12.7969 13.2031 11.8125 12 11.8125C10.7422 11.8125 9.8125 12.7969 9.8125 14C9.8125 15.2578 10.7422 16.1875 12 16.1875C13.2031 16.1875 14.1875 15.2578 14.1875 14ZM22.5 16.1875C23.7031 16.1875 24.6875 15.2578 24.6875 14C24.6875 12.7969 23.7031 11.8125 22.5 11.8125C21.2422 11.8125 20.3125 12.7969 20.3125 14C20.3125 15.2578 21.2422 16.1875 22.5 16.1875Z"
                    fill="#084CD4" />
                <rect x="10" y="21" width="14" height="2" rx="1" fill="#A8C0F1" />
            </svg>
            <p class="section-title-s text-start">Automates Discovery and Mapping</p>
            <p class="section-paragraph-s text-start">The solution automates the process of discovering network devices
                and mapping their relationships. It can scan the network, identify connected devices, and accurately
                represent the network topology.</p>
        </div>

        <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 px-5 mb-5">
            <svg style="max-height: 26px;margin-bottom:20px;" xmlns="http://www.w3.org/2000/svg" width="29" height="29"
                viewBox="0 0 29 29" fill="none">
                <path
                    d="M14.5 0.5C22.2109 0.5 28.5 6.78906 28.5 14.5C28.5 22.2656 22.2109 28.5 14.5 28.5C6.73438 28.5 0.5 22.2656 0.5 14.5C0.5 10.6172 2.08594 7.0625 4.65625 4.54688L5.91406 3.28906L8.375 5.80469L7.11719 7.00781C5.20312 8.92188 4 11.6016 4 14.5C4 20.2969 8.70312 25 14.5 25C20.2969 25 25 20.2969 25 14.5C25 9.30469 21.1719 4.98438 16.25 4.16406V5.75V7.5H12.75V5.75V2.25V0.5H14.5Z"
                    fill="#084CD4" />
                <path
                    d="M11.7891 9.92969H11.7344L16.1094 14.3047L17.0391 15.2344L15.2344 17.0938L14.3047 16.1641L9.92969 11.7891L9 10.8594L10.8594 9L11.7891 9.92969Z"
                    fill="#A8C1F1" />
            </svg>
            <p class="section-title-s text-start">Offers Real-Time Updates</p>
            <p class="section-paragraph-s text-start">Infraon's solution offers real-time updates to reflect changes in
                the network. It can dynamically adjust the network topology diagram as devices are added, removed, or
                reconfigured. This ensures that the network topology information remains up to date.</p>
        </div>

        <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 px-5">
            <svg style="max-height: 26px;margin-bottom:20px;" xmlns="http://www.w3.org/2000/svg" width="28" height="27"
                viewBox="0 0 28 27" fill="none">
                <path
                    d="M0 22.25C0 21.5391 0.546875 20.9375 1.3125 20.9375H4.53906C5.08594 19.1875 6.78125 17.875 8.75 17.875C10.6641 17.875 12.3594 19.1875 12.9062 20.9375H26.6875C27.3984 20.9375 28 21.5391 28 22.25C28 23.0156 27.3984 23.5625 26.6875 23.5625H12.9062C12.3594 25.3672 10.6641 26.625 8.75 26.625C6.78125 26.625 5.08594 25.3672 4.53906 23.5625H1.3125C0.546875 23.5625 0 23.0156 0 22.25ZM5.5 22C5.5 21.0703 9.67969 21.6931 8.75 21.6931C7.76562 21.6931 11.3198 21.3203 11.3198 22.25C11.3198 23.2344 7.76562 22.25 8.75 22.25C9.67969 22.25 5.5 22.9844 5.5 22ZM26.6875 3.4375C27.3984 3.4375 28 4.03906 28 4.75C28 5.51562 27.3984 6.0625 26.6875 6.0625H14.6562C14.1094 7.86719 12.4141 9.125 10.5 9.125C8.53125 9.125 6.83594 7.86719 6.28906 6.0625H1.3125C0.546875 6.0625 0 5.51562 0 4.75C0 4.03906 0.546875 3.4375 1.3125 3.4375H6.28906C6.83594 1.6875 8.53125 0.375 10.5 0.375C12.4141 0.375 14.1094 1.6875 14.6562 3.4375H26.6875ZM12.6992 4.75C12.6992 5.73438 9.41406 4.75 10.3984 4.75C11.3281 4.75 12.25 5.73438 12.25 4.75C12.25 3.82031 11.3281 4.75 10.3984 4.75C9.41406 4.75 12.6992 3.82031 12.6992 4.75Z"
                    fill="#084CD4" />
                <path
                    d="M19.25 9C21.1641 9 22.8594 10.3125 23.4062 12.0625H26.6875C27.3984 12.0625 28 12.6641 28 13.375C28 14.1406 27.3984 14.6875 26.6875 14.6875H23.4062C22.8594 16.4922 21.1641 17.75 19.25 17.75C17.2812 17.75 15.5859 16.4922 15.0391 14.6875H1.3125C0.546875 14.6875 0 14.1406 0 13.375C0 12.6641 0.546875 12.0625 1.3125 12.0625H15.0391C15.5859 10.3125 17.2812 9 19.25 9ZM21 13C21 12.0703 22.4297 13 21.5 13C20.5156 13 23 12.5703 23 13.5C23 14.4844 16.5156 13 17.5 13C18.4297 13 21 13.9844 21 13Z"
                    fill="#AC67F0" />
            </svg>
            <p class="section-title-s text-start">Integrates with Other Systems</p>
            <p class="section-paragraph-s text-start">Infraon's solution offers integration capabilities with other IT
                systems and collaboration tools. This integration facilitates seamless data exchange and collaboration
                across IT teams or departments.</p>
        </div>
    </div>
</section>

<section class="container section-spacing">
    <h2 class="section-title text-center">Related Content</h2>

    <div class="row mx-0">
        <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 p-4">
            <a routerLink="/itim-ims/features/network-discovery">
                <div class="backlink-container bg-white px-5 py-4 h-100">
                    <p class="section-title-s text-start">
                        Network Discovery
                    </p>
                    <p class="section-paragraph-s text-start">
                        Automate the network discovery process with mapping & visualization features
                    </p>
                    <p class="primary-color mb-0">Know more</p>
                </div>
            </a>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 p-4">
            <a routerLink="/itim-ims/features/real-time-network-monitoring">
                <div class="backlink-container bg-white px-5 py-4 h-100">
                    <p class="section-title-s text-start">
                        Real-time Network Monitoring
                    </p>
                    <p class="section-paragraph-s text-start">
                        Real-time network monitoring to proactively detect performance bottlenecks
                    </p>
                    <p class="primary-color mb-0">Know more</p>
                </div>
            </a>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 p-4">
            <a routerLink="/itim-ims/features/network-performance-management">
                <div class="backlink-container bg-white px-5 py-4 h-100">
                    <p class="section-title-s text-start">
                        Network Performance Management
                    </p>
                    <p class="section-paragraph-s text-start">
                        Monitor network performance changes & minimize degradation with end-to-end features
                    </p>
                    <p class="primary-color mb-0">Know more</p>
                </div>
            </a>
        </div>
    </div>
</section>

<section class="section-spacing bg-grey">
    <div class="container" id="g2-box-wrapper">
        <div class="g2-box justify-content-between">
            <img loading="lazy" src="/assets/img/feature-pages/g2.svg" alt="G2 Logo">
            <p>Already love using our products? Please <br> share your experiences on G2</p>
            <a href="https://www.g2.com/products/infraon-assets/reviews" class="primary-button">Rate us</a>
        </div>
    </div>
</section>